import { Trophy, Medal, Award, Crown } from "lucide-react";

export const BADGE_STYLES = {
  bronze: { icon: Medal, text: "text-[#8C5A2B]", bg: "bg-[#8C5A2B]/10", ring: "ring-[#8C5A2B]/30", hex: "#B87333" },
  silver: { icon: Award, text: "text-slate-600", bg: "bg-slate-400/15", ring: "ring-slate-400/40", hex: "#A8B0BC" },
  gold: { icon: Trophy, text: "text-[#9A6B00]", bg: "bg-talanta-gold/20", ring: "ring-talanta-gold/50", hex: "#E5A93C" },
  champion: { icon: Crown, text: "text-talanta-red", bg: "bg-talanta-red/10", ring: "ring-talanta-red/40", hex: "#DC2626" },
};

export const BADGE_TIERS = [
  { id: "champion", label: "Champion", min: 50 },
  { id: "gold", label: "Gold", min: 15 },
  { id: "silver", label: "Silver", min: 5 },
  { id: "bronze", label: "Bronze", min: 1 },
];

export const badgeFor = (invites = 0) => {
  const b = BADGE_TIERS.find((t) => invites >= t.min);
  return b ? { ...b, hex: BADGE_STYLES[b.id].hex } : null;
};

export const BadgePill = ({ badge, size = "sm", testId, dark = false }) => {
  if (!badge) return null;
  const s = BADGE_STYLES[badge.id] || BADGE_STYLES.bronze;
  const Icon = s.icon;
  const cls = size === "lg" ? "px-3 py-1.5 text-sm gap-2" : "px-2 py-0.5 text-[11px] gap-1";
  if (dark) {
    return (
      <span data-testid={testId} className={`inline-flex items-center rounded-full font-semibold bg-white/10 ring-1 ring-white/15 text-white ${cls}`}>
        <Icon className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} style={{ color: s.hex }} /> {badge.label}
      </span>
    );
  }
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full font-semibold ring-1 ${s.bg} ${s.text} ${s.ring} ${cls}`}>
      <Icon className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} /> {badge.label}
    </span>
  );
};
